import { render, staticRenderFns } from "./TransferirLeito.vue?vue&type=template&id=181a9e17&"
import script from "./TransferirLeito.vue?vue&type=script&lang=js&"
export * from "./TransferirLeito.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports